import React from 'react';
import DocumentHeader from '../../../Documents/components/DocumentHeader';
import DeleteOriginalPreview from './DeleteOriginalPreview';
import DeleteNewPreview from './DeleteNewPreview';
import DeleteReplaceConfirmModal from './DeleteReplaceConfirmModal';
import DeleteModal from '../../../../common/DeleteModal';
import Loader from '../../../../common/Loader';

/**
 * DeleteReplacePreview Component
 * Displays the preview of original vs new document state after delete
 */
const DeleteReplacePreview = ({
  deleteDocument,
  deleteNode,
  previewMode,
  originalData,
  newData,
  onPreviewModeChange,
  onConfirm,
  comment,
  onCommentChange,
  isLoading,
  isModalOpen,
  onModalClose,
  onOpenSaveModal,
  isFirstConfirmModalOpen,
  onFirstConfirmModalClose,
  procedureType,
  revisionStatus
}) => {
  // Handle first confirmation modal - when user clicks "Delete" on the confirmation modal
  const handleFirstConfirm = () => {
    if (onFirstConfirmModalClose) {
      onFirstConfirmModalClose();
    }
    // Open the Save Modal (comment modal)
    if (onOpenSaveModal) {
      onOpenSaveModal();
    }
  };

  const handleModalSave = () => {
    if (onConfirm) {
      onConfirm();
    }
    if (onModalClose) {
      onModalClose();
    }
  };

  return (
    <div style={{ padding: '20px', position: 'relative' }}>
      {/* Document Header - Show target document header above preview */}
      {deleteDocument && (
        <DocumentHeader
          type={procedureType || deleteDocument.type}
          partNumber={deleteDocument.partNumber}
          revision={deleteDocument.revision}
          revisionId={deleteDocument.revisionId}
          partId={deleteDocument.partId}
          // description={deleteDocument.description}
          description={false}
          status={revisionStatus || 'Not Submitted'}
          currentRevision={null}
          showCheckbox={false}
          showVersionInfo={false}
          isCheckboxEnabled={false}
        />
      )}

      {/* Preview Content */}
      {previewMode === 'original' ? (
        <DeleteOriginalPreview
          data={originalData}
          deleteDocument={deleteDocument}
        />
      ) : (
        <DeleteNewPreview
          originalData={originalData}
          deleteDocument={deleteDocument}
          newData={newData}
        />
      )}

      {/* First Confirmation Modal - "Are you sure, you want to delete..." */}
      <DeleteModal
        isOpen={isFirstConfirmModalOpen}
        onClose={onFirstConfirmModalClose}
        title="Delete Confirmation"
        itemName={deleteNode?.nodeTitle || ''}
        partNumber={deleteDocument?.partNumber || ''}
        type={procedureType || deleteDocument?.type || ''}
        revision={deleteDocument?.revision || ''}
        isLoading={isLoading}
        onConfirm={handleFirstConfirm}
        isConfirmModal={true}
      />

      {/* Save Modal - Comment Modal */}
      {isModalOpen && (
        <DeleteReplaceConfirmModal
          deleteDocument={deleteDocument}
          deleteNode={deleteNode}
          comment={comment}
          onCommentChange={onCommentChange}
          onClose={onModalClose}
          onSave={handleModalSave}
          isLoading={isLoading}
          procedureType={procedureType || deleteDocument?.type}
        />
      )}

      {/* Submitting overlay loader */}
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Loader text="Deleting" />
        </div>
      )}
    </div>
  );
};

export default DeleteReplacePreview;

